import SuccessIcon from "./SuccessIcon";
import UniversalLoginWidget from "./UniversalLoginWidget";

/**
 * Layout of the standard reset-password-success screen, measured off the live
 * hosted page on 2026-10-13 (the hosted reset-password-error page shares it,
 * but that screen stays standard; see auth0.tf):
 *
 *   NO logo (the hosted status screens draw none)
 *   88px icon, 24px gap
 *   title   24px / weight 400 / 36px line / body-text colour, 16px gap
 *   body    14px / 22.4px line / centred / body-text colour
 *   button  52px pill, 320 wide, 24px above, a LINK (<a>) not a <button>
 *   all of it centred vertically in the 400x540 card
 *
 * Note the title is NOT the form screen's bold header colour. The hosted
 * status pages use regular weight in the body-text grey, and copying the
 * form screen's title style here was the easy mistake to make.
 */
interface StatusScreenProps {
  title: string;
  description: string;
  backLabel: string | null;
  backHref: string | null;
}

export default function StatusScreen({
  title,
  description,
  backLabel,
  backHref,
}: StatusScreenProps) {
  return (
    <UniversalLoginWidget className="p-10">
      <SuccessIcon />
      <section className="flex flex-col text-center">
        <h1
          className="m-0 mb-4"
          style={{
            fontSize: "var(--ul-theme-font-title-size, 1.5rem)",
            lineHeight: "36px",
            fontWeight: 400,
            color: "var(--ul-theme-color-body-text, #4b5563)",
          }}
        >
          {title}
        </h1>
        <p
          className="m-0 mb-4"
          style={{
            fontSize: "var(--ul-theme-font-body-text-size, 0.875rem)",
            lineHeight: 1.6,
            color: "var(--ul-theme-color-body-text, #4b5563)",
          }}
        >
          {description}
        </p>
        {/* Same as hosted: when Auth0 can resolve no login route it renders no
         * button at all, rather than a dead one. */}
        {backHref && backLabel ? (
          <a
            href={backHref}
            className="mt-2 flex h-[52px] w-full items-center justify-center px-4 no-underline rounded-[var(--ul-theme-border-button-border-radius,9999px)] hover:shadow-[inset_0_0_0_150px_rgba(0,0,0,0.1)] focus:outline-none focus-visible:ring-4"
            style={{
              backgroundColor: "var(--ul-theme-color-primary-button, #294fed)",
              color: "var(--ul-theme-color-primary-button-label, #ffffff)",
              fontSize: "var(--ul-theme-font-buttons-text-size, 1rem)",
              lineHeight: "24px",
            }}
          >
            {backLabel}
          </a>
        ) : null}
      </section>
    </UniversalLoginWidget>
  );
}
